import { Rol } from './rol';

export class Usuario {
  id: number;
  nombre: string;
  rol: Rol;
  usuario: string;
  correo: string;
  dni: string;
  avatar: string;
  habDesd: string;
  habHast: string;
  activo: Boolean;

  constructor() {
    this.rol = new Rol();
    this.rol.id = 4
    this.avatar = "default.png";
    this.habDesd = "00:00";
    this.habHast = "23:59"
    this.activo = false;
  }

}